<template>
  <div id="cnt_users">
  </div>  
</template>
<script>
export default {
    mounted() {
        let fhs = document.createElement('script');
        let fhs_id = "5599837";
        let ref = (''+document.referrer+'');
        let pn =  window.location;
        let w_h = window.screen.width + " x " + window.screen.height;
        fhs.src = "//freehostedscripts.net/ocounter.php?site="+fhs_id+"&e1= &e2= &r="+ref+"&wh="+w_h+"&a=1&pn="+pn+"";
        document.head.appendChild(fhs);
        let boxCnt = document.getElementById('cnt_users');
        boxCnt.innerHTML = "<span id='o_"+fhs_id+"'></span>";
    }
}
</script>
<style scoped>
 #cnt_users {
    font-family: Arimo;
    font-size: 13px;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.15;
    letter-spacing: 0.4px;
    color: #fff !important;
    text-decoration: none !important;
    }
a {
    font-family: Arimo;
    font-size: 13px;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.15;
    letter-spacing: 0.4px;
    color: #fff !important;
    text-decoration: none !important;
}
</style>
